export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Fornecedor criado com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar Fornecedor.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
